// Firebase setup and services
import { initializeApp } from "firebase/app";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  query,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
});
const functions = getFunctions(firebaseApp);
// connectFunctionsEmulator(functions, "localhost", 5001); // Use local functions

export const getQuestions = async () => {
  const questionQuery = query(collection(db, "DCM_questions"));
  const snapshot = await getDocs(questionQuery);
  const dcmVersion = snapshot.docs
    .find((doc) => doc.id === process.env.REACT_APP_DCM_VERSION)
    .data();
  return { questions: dcmVersion.questions };
};

export const getHistory = async (clientSlug) => {
  const historyDoc = doc(db, "DCM_answers", clientSlug);
  const historySnapshot = await getDoc(historyDoc);
  if (!historySnapshot.exists()) {
    return {};
  } else {
    return historySnapshot.data();
  }
};

export const hasAccess = async (email) => {
  const validateAccess = httpsCallable(functions, "validateAccess");
  const response = await validateAccess({ email });
  return response.data;
};

export const setAggregate = async (data) => {
  Object.keys(data).forEach((ag) => {
    setDoc(doc(db, "DCM_aggregate", ag), data[ag]);
  });
};

export const saveProgress = async (clientSlug, data) => {
  const checkDoc = await getDoc(doc(db, "DCM_answers", clientSlug));

  if (!checkDoc.exists()) {
    await setDoc(doc(db, "DCM_answers", clientSlug), data);
  } else {
    await updateDoc(doc(db, "DCM_answers", clientSlug), data);
  }
};

export const setResults = async (clientSlug, data) => {
  await setDoc(doc(db, "DCM_answers", clientSlug), data);
};

export async function getBigQueryAggregate() {
  const getAggregates = httpsCallable(functions, "getAggregates");

  try {
    const data = await getAggregates();
    console.log("BigQuery data", data.data);

    return data.data;
  } catch (err) {
    console.error(`Error retrieving aggregate data\n${err.message}`);
    return { code: err?.message || "Error retrieving aggregate data" };
  }
}

export async function mailReport(file, filename, companyName) {
  const sendReport = httpsCallable(functions, "sendReport");

  const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const encodedFile = await blobToBase64(file);

  try {
    await sendReport({ encodedFile, filename, companyName });
    console.log("Report sent successfully");
    return true;
  } catch (err) {
    console.error(`Error sending report\n${err.message}`);
    return false;
  }
}
